import { GlobalModalOptions } from 'store/modal/actions';
import * as track from 'lib/gaTracking/crossPageEvents';
import { ModalBody, ContactUsResolution } from './errorModalPrimitives';
import { ReactNode } from 'react';
import * as codes from './errorCodes';

const headers = {
  somethingWentWrong: 'Sorry, something went wrong',
  cardExpired: 'Your credit card has expired',
  unexpected: 'There was an unexpected error',
};

const body = {
  cardDeclined: 'There was a problem and your changes have not been completed.',
  cardExpired: 'There was a problem and your changes have not been completed.',
  insufficientFunds: 'We were unable to process payment due to insufficient funds, and your changes have not been completed.',
  comeBackLater: 'Please come back and try again later.',
};

const resolutions = {
  contactUs: <ContactUsResolution />,
  checkCardDetails: 'Please check your credit card details or contact your financial institution.',
};

export function getErrorModalOptions(errorCode: string): Partial<GlobalModalOptions> {
  if (errorCode === codes.PAYMENT_FAILED_CREDIT_CARD_DECLINED) {
    return createOptions({
      header: headers.somethingWentWrong,
      content: body.cardDeclined,
      resolution: resolutions.contactUs,
    });
  } else if (errorCode === codes.PAYMENT_FAILED_CREDIT_CARD_EXPIRED) {
    return createOptions({
      header: headers.cardExpired,
      content: body.cardExpired,
      resolution: resolutions.contactUs,
    });
  } else if (errorCode === codes.REFUND_FAILED_CREDIT_CARD_EXPIRED) {
    return createOptions({
      header: headers.cardExpired,
      content: body.cardExpired,
      resolution: resolutions.contactUs,
    });
  } else if (errorCode === codes.PAYMENT_FAILED_CREDIT_CARD_INSUFFICIENT_BALANCE) {
    return createOptions({
      header: headers.somethingWentWrong,
      content: body.insufficientFunds,
      resolution: resolutions.checkCardDetails,
    });
  } else if (errorCode === codes.PAYMENT_FAILED_POINTS_INSUFFICIENT_BALANCE) {
    return createOptions({
      header: headers.somethingWentWrong,
      content: body.insufficientFunds,
      resolution: resolutions.contactUs,
    });
  } else {
    return createOptions({
      header: headers.unexpected,
      content: body.comeBackLater,
      resolution: resolutions.contactUs,
    });
  }
}

function createOptions(options: { header: string; content: ReactNode; resolution: ReactNode }): Partial<GlobalModalOptions> {
  return {
    variant: 'error',
    onClose: track.modalCloseButton,
    header: options.header,
    body: <ModalBody content={options.content} resolution={options.resolution} />,
  };
}
